const Onboarding: React.FC = () => {
    window.location.href = "https://forms.gle/aHvH2MdHSt6WwrAd6";

    return <div>
        
    </div>
}

export default Onboarding;